export default "__VITE_ASSET__D85AenBI__"